import { render, staticRenderFns } from "./SidebarCiudadano.vue?vue&type=template&id=6d8aeee2&scoped=true&"
import script from "./SidebarCiudadano.vue?vue&type=script&lang=ts&"
export * from "./SidebarCiudadano.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarCiudadano.vue?vue&type=style&index=0&id=6d8aeee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8aeee2",
  null
  
)

export default component.exports